import { IDeceasedContact } from '~/types/IDeceasedContact';
import { siteAxios } from '~/App/helpers/http';

export const deceasedContact = {
  search: async (q: string, created_from: string) => {
    const { data } = await siteAxios.get<IDeceasedContact[]>(
      '/api/v2/mw/bitnet/deceased_contacts',
      {
        params: {
          q,
          created_from
        }
      }
    );

    return data;
  }
};
